import { Controller } from "@hotwired/stimulus"

// Stack of the newest photos on the check lists. With a mouse, the pointer position leafs through the stack (the
// photo under the pointer's third moves to the front). On touch screens a tap fans the stack out, and another tap, a tap
// elsewhere or scrolling it out of view closes it. The positions are data-pos attributes; the CSS draws them.
export default class extends Controller {
  static targets = ["item"]
  static values = { open: Boolean }

  connect() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) this.openValue = false
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
  }

  browse(event) {
    if (this.touch || !this.fannable) return

    const { left, width } = this.element.getBoundingClientRect()
    const fraction = Math.min(Math.max((event.clientX - left) / width, 0), 0.999)
    this.bringToFront(Math.floor(fraction * this.itemTargets.length))
  }

  reset() {
    if (!this.touch) this.bringToFront(0)
  }

  toggle(event) {
    // detail 0 is a keyboard or assistive-technology activation: it follows the link instead of fanning
    if (!this.touch || !this.fannable || event.detail === 0) return

    event.preventDefault()
    this.openValue = !this.openValue
  }

  closeOutside(event) {
    if (this.openValue && !this.element.contains(event.target)) this.openValue = false
  }

  bringToFront(front) {
    const count = this.itemTargets.length
    this.itemTargets.forEach((item, index) => {
      item.dataset.pos = (index - front + count) % count
    })
  }

  get fannable() {
    return this.itemTargets.length > 1
  }

  get touch() {
    return window.matchMedia("(hover: none)").matches
  }
}
